export const DEFAULT_HEALTHCHECK_TIMEOUT = 2000;
